import React from 'react';
import { Descriptions } from 'antd';
import PropTypes from 'prop-types';
import EmptyDataPlaceholder from '../../../../components/EmptyDataPlaceholder';



const HTMLCodePreview = ({ data = '' }) => {
  const lines = data.split('\n').map((line, index) => ({
    lineNumber: index + 1,
    content: line,
  }));

  return (
    <Descriptions column={1} className='collapse-html-content'>
      {lines.length ? lines.map(({ lineNumber, content }) => (
        <Descriptions.Item key={lineNumber}>
          <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
            {content || '\u00A0'}
          </pre>
        </Descriptions.Item>
      )) : <EmptyDataPlaceholder />}
    </Descriptions>
  );
};

HTMLCodePreview.propTypes = {
  data: PropTypes.string,
};

export default HTMLCodePreview;
